import React from 'react';
import { SpriteIcon } from '@/components/ui/SvgSprite';

/** 5 small stars, the last one filled in part (e.g. 4.3 → 4 full + 30%). */
const AverageStars = ({ value, size = 'size-5' }: { value: number; size?: string }) => (
    <div className='flex gap-0.5' aria-hidden='true'>
        {[1, 2, 3, 4, 5].map((i) => {
            const fill = Math.max(0, Math.min(1, value - (i - 1)));
            return (
                <span key={i} className={`relative inline-block ${size}`}>
                    <SpriteIcon
                        name='star'
                        className={`absolute inset-0 ${size} stroke-gray-300 dark:stroke-white/25`}
                    />
                    <span
                        className='absolute inset-y-0 right-0 overflow-hidden'
                        style={{ width: `${fill * 100}%` }}
                    >
                        {/* pinned to the right so an RTL partial star fills from its start */}
                        <SpriteIcon
                            name='star'
                            className={`absolute right-0 top-0 ${size} max-w-none fill-yellow-400 stroke-yellow-400`}
                        />
                    </span>
                </span>
            );
        })}
    </div>
);

export default AverageStars;
